import formSponsorEdit from './formSponsorEdit';

export default {
  title: 'Sponsor Edit',
  attributeName:'sponsors',
  createURL: 'sponsors',
  sessionParams: [],
  getURL: 'sponsors',
  updateURL: 'sponsors',
  idAttribute: 'id',
  noArea: true,
  goBack: true,
  autoUpdate: false,
  idUpdate:true,
  formConfig: [
    formSponsorEdit,
  ],
};
